import styles from './AcfInput.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { FormButton, FormInput, FormTextArea } from '@/components';

let cx = className.bind(styles);

export default function AcfInput(props) {
	const { input, attributes, id } = props;
	const className = attributes.className?.split(' ') || [];
	const type = input.type[0] || null;

	if (!type) {
		throw Error('ACF Input type not set.');
	} else if (type === 'submit') {
		return <FormButton id={attributes.anchor} text={input.value} value={input.value} className={cx([attributes.alignInput && `align-${attributes.alignInput}`, ...className])} />;
	} else if (type === 'text area') {
		return (
			<FormTextArea
				label={input.label}
				name={input.name}
				id={attributes.anchor || `input-${id}`}
				className={cx([attributes.alignInput && `align-${attributes.alignInput}`, ...className])}
				placeholder={input.placeholder}
				value={input.value}
				required={{
					value: input.required,
					message: input.requiredErrorMessage,
				}}
				minLength={{
					value: input.minLength,
					message: input.minLengthErrorMessage,
				}}
				maxLength={{
					value: input.maxLength,
					message: input.maxLengthErrorMessage,
				}}
        rows={input.rows}
			/>
		);
	} else {
		return (
			<FormInput
				type={input.type[0]}
				label={input.label}
				name={input.name}
				id={attributes.anchor || `input-${id}`}
				className={cx([attributes.alignInput && `align-${attributes.alignInput}`, ...className])}
				placeholder={input.placeholder}
				checked={input.checked}
				value={input.value}
				required={{
					value: input.required,
					message: input.requiredErrorMessage,
				}}
				minLength={{
					value: input.minLength,
					message: input.minLengthErrorMessage,
				}}
				maxLength={{
					value: input.maxLength,
					message: input.maxLengthErrorMessage,
				}}
				pattern={{
					value: input.pattern,
					message: input.patternErrorMessage,
				}}
				min={{
					value: input.min,
					message: input.minErrorMessage,
				}}
				max={{
					value: input.max,
					message: input.maxErrorMessage,
				}}
			/>
		);
	}
}

AcfInput.fragments = {
	key: `AcfInputFragment`,
	entry: gql`
		fragment AcfInputFragment on AcfInput {
			attributes {
				anchor
				className
				alignInput: align
			}
			input {
				type
				name
				label
				value
				placeholder
				required
				requiredErrorMessage
				minLength
				minLengthErrorMessage
				maxLength
				maxLengthErrorMessage
				min
				minErrorMessage
				max
				maxErrorMessage
				pattern
				patternErrorMessage
				checked
        rows
			}
		}
	`,
};

AcfInput.config = {
	name: 'AcfInput',
};
AcfInput.displayName = 'AcfInput';
